import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'adc-tabview',
  templateUrl: './adc-tabview.component.html',
  styleUrls: ['./adc-tabview.component.scss'],
  standalone: false
})
export class AdcTabviewComponent implements OnInit {
  @Input('type') type: string = 'type1';
  @Input() tabGrp: any;
  @Input() data: any;
  activeTab: number = 1;
  showBody: boolean = true;
  loading: boolean = false;
  breadcrumbActive: string = '';
  // tabTitle: any;
  // tabContent: any;
  // tabTarget: any;
  // id: any;

  ngOnInit(): void {
    // console.log(this.data[0].tabTitle);
    // this.tabTitle = this.data[0].tabTitle;
    // this.tabContent = this.data[0].tabContent;
    // this.tabTarget = this.data[0].tabTarget;
    // this.id = this.data[0].id;
    // const tabContainers = document.querySelectorAll('.adc-tab-view');

    // tabContainers.forEach((container) => {
    //   const tabButtons = container.querySelectorAll('.adc-tab-button');
    //   const tabContent = container.querySelectorAll('.adc-tab-pane');

    //   tabButtons.forEach((button, index) => {
    //     button.addEventListener('click', () => {
    //       this.loading = true;
    //       this.showBody = false;
    //       setTimeout(() => {
    //         this.loading = false;
    //         this.showBody = true;
    //       }, 1500);
    //       console.log(this.loading)
    //       const target = button.getAttribute('data-tab-target');
    //       tabContent.forEach((content) => {
    //         content.classList.remove('active');
    //         if (content.getAttribute('data-tab-name') === target) {
    //           content.classList.add('active');
    //         }
    //       });

    //       tabButtons.forEach((btn) => {
    //         btn.classList.remove('active');
    //       });

    //       button.classList.add('active');
    //     });

    //     if (index === 0) {
    //       button.dispatchEvent(new Event('click'));
    //     }
    //   });
    // });
    // this.toggleTabs()
  }
  // loading: boolean = false;
  // showBody: boolean = true;

  @ViewChildren('tabButton') tabButtons!: QueryList<any>;
  @ViewChildren('tabContent') tabContents!: QueryList<any>;

  ngAfterViewInit(): void {
    this.tabButtons.toArray().forEach((button, index) => {
      button.nativeElement.addEventListener('click', () => {
        this.loading = true;
        this.showBody = false;
        setTimeout(() => {
          this.loading = false;
          this.showBody = true;
        }, 1500);

        const target = button.nativeElement.getAttribute('data-tab-target');
        this.tabContents.toArray().forEach(content => {
          content.nativeElement.classList.remove('active');
          if (content.nativeElement.getAttribute('data-tab-name') === target) {
            content.nativeElement.classList.add('active');
          }
        });

        this.tabButtons.toArray().forEach(btn => {
          btn.nativeElement.classList.remove('active');
        });

        button.nativeElement.classList.add('active');
      });

      if (index === 0) {
        button.nativeElement.dispatchEvent(new Event('click'));
      }
    });
  }
  activeTabs: string = '';

  activateTab(tabTarget: string) {
    this.activeTabs = tabTarget;
  } 

  toggleTabs() {
    const data = [
      { id: 1, tabTitle: 'Tab 1', tabContent: '1Lorem ipsum dolor sit amet consectetur adipisicing elit', tabTarget: 'tab1' },
      // ... (other data objects)
      { id: 11, tabTitle: 'Tab 11', tabContent: '11Lorem ipsum dolor sit amet consectetur adipisicing elit', tabTarget: 'tab11' }
    ];
    
    function activateTab(tabTarget: any) {
      const tabContents = document.querySelectorAll('.adc-tab-pane');
      const tabButtons = document.querySelectorAll('.adc-tab-button');
    
      tabContents.forEach(content => {
        content.classList.remove('active');
        if (content.getAttribute('data-tab-name') === tabTarget) {
          content.classList.add('active');
        }
      });
    
      tabButtons.forEach(button => {
        button.classList.remove('active');
        if (button.getAttribute('data-tab-target') === tabTarget) {
          button.classList.add('active');
        }
      });
    }
    
    const tabButtonsContainer = document.getElementById('tabButtons');
    const tabContentsContainer = document.getElementById('tabContents');
    
    data.forEach(tab => {
      const button = document.createElement('div');
      button.classList.add('adc-tab-button', 'adc-tab-bs1');
      button.setAttribute('data-tab-target', tab.tabTarget);
      button.textContent = tab.tabTitle;
      button.addEventListener('click', () => {
        activateTab(tab.tabTarget);
      });
      tabButtonsContainer!.appendChild(button);
    
      const content = document.createElement('div');
      content.classList.add('adc-tab-pane', 'adc-tab-ps1');
      content.setAttribute('data-tab-name', tab.tabTarget);
      content.textContent = tab.tabContent;
      tabContentsContainer!.appendChild(content);
    });
    
    // Activate the first tab by default
    const firstTabButton = document.querySelector('.adc-tab-button');
    if (firstTabButton) {
      const clickEvent = new Event('click');
      firstTabButton.dispatchEvent(clickEvent);
    }
  }

  toggleActive(breadcrumbNo: string) {
    this.breadcrumbActive = breadcrumbNo;
  }
}
